import { getConfig } from '../../../config';
import { revFY25_01Classifier } from './fy25_01';
import { revFY25_02Classifier } from './fy25_02';
export function getRevisions() {
  var _getConfig;
  if (!((_getConfig = getConfig()) !== null && _getConfig !== void 0 && (_getConfig = _getConfig.vc) !== null && _getConfig !== void 0 && (_getConfig = _getConfig.enabledVCRevisions) !== null && _getConfig !== void 0 && _getConfig.includes('fy25.01'))) {
    return [{
      name: 'fy25.02',
      classifier: revFY25_02Classifier
    }];
  }
  return [{
    name: 'fy25.01',
    classifier: revFY25_01Classifier
  }, {
    name: 'fy25.02',
    classifier: revFY25_02Classifier
  }];
}